import { Service, signal } from '@angular/core';

@Service()
export class DeviceService {
    public readonly isMobile = signal<boolean>(window.innerWidth <= 1024);
    // public readonly resolution = signal<number>(window.innerWidth);

    // public readonly isMobile = computed(() => {
    //     return this.resolution() < 1024;
    // });

    constructor() {
        window.addEventListener('resize', () => {
            this.isMobile.set(window.innerWidth <= 1024);
            // this.resolution.set(window.innerWidth);
        });
    }
}
